import { IPackageProgramTier, PACKAGE_DISCOUNT_TYPE } from 'services/shop/types/package-program';
import { formatCurrency } from 'utils/formatCurrency';

/** setting chỉ cho phép tối đa 3 tier trên một program */
export const MAX_PACKAGE_TIERS = 3;

// Sort bản copy theo sortOrder (sort ổn định nên tier trùng sortOrder giữ thứ tự API), cắt tối đa 3 tier
export const sortPackageTiers = (tiers: IPackageProgramTier[] = []): IPackageProgramTier[] =>
  [...tiers].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)).slice(0, MAX_PACKAGE_TIERS);

export const formatPackageSaveLabel = (tier: Pick<IPackageProgramTier, 'discountType' | 'discountValue'>) =>
  tier.discountType === PACKAGE_DISCOUNT_TYPE.MONEY
    ? `SAVE ${formatCurrency(tier.discountValue)}`
    : `SAVE ${tier.discountValue}%`;

// BE đang bổ sung validityMonths theo tier; null nghĩa là ẩn dòng "Valid for … months"
export const getPackageTierValidityMonths = (tier: Pick<IPackageProgramTier, 'validityMonths'>): number | null =>
  typeof tier.validityMonths === 'number' && tier.validityMonths > 0 ? tier.validityMonths : null;
